<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-08-21 10:31:19
-->
<template>
    <div>
        <!-- <a-collapse class="collapse" :default-active-key="['1']" accordion :onChange="onChange">
            <a-collapse-item :header="$t('base.search')" key="1">
                <Form :form="exchangeQueryForm" @handleSelectChange="handleSelectChange">
                    <template v-slot:formBtn>
                        <div style="margin-left:-110px">
                            <a-button class="form_btn" type="primary" @click="handle('search')">{{ $t('base.search') }}</a-button>
                            <a-button class="form_btn" type="outline" @click="handle('reset')">{{ $t('base.reset') }}</a-button>
                        </div>
                    </template>
                </Form>
            </a-collapse-item>
        </a-collapse> -->

        <Table
            ref="orderTableRef"
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <!-- 自定义字段 -->
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'status'">
                    <a-tag :color="statusColor[props.record.status_val]">{{ props.record.status }}</a-tag>
                </div>
                <div v-if="props.column.key == 'back_courier_status'">
                    <a-tag v-if="props.record.back_courier_status !== '-'" :color="courierStatusColor[props.record.back_courier_status_val]">{{ props.record.back_courier_status }}</a-tag>
                    <span v-else>-</span>
                </div>
            </template>

            <!-- 表格操作 -->
            <template v-slot:tableOperate="{ props }">
                <a-button type="primary" size="mini" :disabled="!props.record.file" @click="handle('seeFile',props.record)">{{ $t('returnExchange.seeFile') }}</a-button>   
            </template>
        </Table>

        <!-- 查看附件 -->
        <ImagePreview :srcList="srcList" :visibleImg="visible" @close="close"/>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import ImagePreview from '@/components/ImagePreview.vue';
    import { ExchangeQueryForm } from './queryConfig/OrderListQuery.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';

    const props = defineProps({
        visible:{
            type:Boolean,
            default:false,
        },
        rowData:{
            type:Object,
            default:()=>{}
        }
    })

    const { t } = useI18n()
    const exchangeQueryForm = reactive(ExchangeQueryForm)
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '返修单号',
                title:t('returnExchange.returnFactoryNumber'),
                dataIndex: 'swap_number',
                key:'swap_number',
                width:'190',
                align:'center',
                ellipsis:true,
                tooltip:true,
                fixed:'left'
            },
            {
                // title: 'mes退货货单号',
                title:t('returnExchange.backNumber'),
                dataIndex: 'back_number',
                key:'back_number',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
                fixed:'left'
            },
            {
                // title: '产品名称',
                title:t('returnExchange.productName'),
                dataIndex: 'product_name',
                key:'product_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: 'sku',
                title:t('returnExchange.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'150',
                align:'center',
            },  
            {
                // title: 'ERP编号',
                title:t('returnExchange.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'130',
                align:'center',
            },
            {
                // title: '订单行号',
                title:t('returnExchange.erpLineNo'),
                dataIndex: 'erp_line_no',
                key:'erp_line_no',
                width:'140',
                align:'center',
            },
            {
                // title: 'erp物料号',
                title:t('returnExchange.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '车型',
                title:t('order.model'),
                dataIndex: 'model',
                key:'model',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '上市年份',
                title:t('order.modelYear'),
                dataIndex: 'model_year',
                key:'model_year',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '品牌名称',
                title:t('order.brandName'),
                dataIndex: 'brand_name',
                key:'brand_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '零件名称',
                title:t('order.partName'),
                dataIndex: 'part_name',
                key:'part_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '状态',
                title:t('returnExchange.status'),
                dataIndex: 'status',
                key:'status',
                width:'170',
                align:'center',
                slotName:'slot'
            },
            {
                // title: '来源',
                title:t('returnExchange.source'),
                dataIndex: 'source',
                key:'source',
                width:'120',
                align:'center',
            },
            {
                // title: '返修原因类型',
                title:t('returnExchange.returnFactoryReasonType'),
                dataIndex: 'back_reason_type',
                key:'back_reason_type',
                width:'200',
                align:'center',
            },  
            {
                // title: '返修原因',
                title:t('returnExchange.returnFactoryReason'),
                dataIndex: 'back_reason',
                key:'back_reason',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '返修物料编码',
                title:t('returnExchange.returnFactoryInventoryCode'),
                dataIndex: 'swap_inventory_code',
                key:'swap_inventory_code',
                width:'240',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '返修发货仓库',
                title:t('returnExchange.warehouse'),
                dataIndex: 'swap_inventory',
                key:'swap_inventory',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '返修数量',
                title:t('returnExchange.returnFactoryQty'),
                dataIndex: 'swap_quantity',
                key:'swap_quantity',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '返修计划发货日期',
                title:t('returnExchange.returnFactoryTimestampPlan2'),
                dataIndex: 'swap_timestamp_plan',
                key:'swap_timestamp_plan',
                width:'200',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '返修实际发货日期',
                title:t('returnExchange.returnFactoryTimestampReal'),
                dataIndex: 'swap_timestamp_real',
                key:'swap_timestamp_real',
                width:'200',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'IBS验证方案类型',
                title:t('returnExchange.ibsVerificationType'),
                dataIndex: 'ibs_verification_type',
                key:'ibs_verification_type',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'IBS验证方案描述',
                title:t('returnExchange.ibsVerificationPlan'),
                dataIndex: 'ibs_verification_plan',
                key:'ibs_verification_plan',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '客户名称',
                title:t('returnExchange.customerName'),
                dataIndex: 'customer_name',
                key:'customer_name',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'erp客户编码',
                title:t('returnExchange.customerErpCode'),
                dataIndex: 'customer_erp_code',
                key:'customer_erp_code',
                width:'200',
                align:'center',
            },
            {
                // title: '退货物流状态',
                title:t('returnExchange.backCourierStatus'),
                dataIndex: 'back_courier_status',
                key:'back_courier_status',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '退货物流单号',
                title:t('returnExchange.backCourierNo'),
                dataIndex: 'back_courier_no',
                key:'back_courier_no',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '退货物流公司',
                title:t('returnExchange.backCourierType'),
                dataIndex: 'back_courier_type',
                key:'back_courier_type',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 返修发货物流单号',
                title:t('returnExchange.returnFactoryCourierNo2'),
                dataIndex: 'swap_courier_no',
                key:'swap_courier_no',
                width:'220',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '返修发货物流公司',
                title:t('returnExchange.returnFactoryCourierType2'),
                dataIndex: 'swap_courier_type',
                key:'swap_courier_type',
                width:'250',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '150',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 480
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false
            
        },
    })
    const srcList = ref([])
    const visible = ref(false)
    const reasonTypeObj = ref({})
    const sourceObj = ref({})
    const IBSTypeObj = ref({})
    const statusObj = {
        0:t('returnExchange.initial'),
        // 1:t('returnExchange.returning'),
        1:t('returnExchange.returningFactory'),
        // 3:t('returnExchange.returnSuccessful'),
        2:t('returnExchange.returnFactorySuccessful'),
        // 3:t('stock.cancelSwap2'),
    }
    const statusColor = ref({
        // 0:'blue',
        // 1:'red',
        // 2:'orange',
        // 3:'lime',
        // 4:'green',
        0:'blue',
        1:'red',
        2:'green',
        3:'orange',
    })

    const courierStatus = ref({ // 退货物流状态
        0:t('order.unship'),
        1:t('order.plan'),
        2:t('order.partialShip'),
        3:t('order.shiped'),
        4:t('order.signedFor'),
        5:t('order.cancel'),
    })
    
    const courierStatusColor = ref({
        0:'red',
        1:'plan',
        2:'orange',
        3:'lime',
        4:'green',
        5:'gray',
    })

    const formatField = (key,data)=>{
        if(key == 'status'){
            return statusObj[data]
        }else if(key == 'source'){
            return sourceObj.value[data]
        }else if(key == 'back_reason_type'){
            return reasonTypeObj.value[data]
        }else if(key == 'ibs_verification_type'){
            return IBSTypeObj.value[data]
        }
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                getExchangeList()
                break;
            case 'reset':
                exchangeQueryForm.formField.forEach(i=>{
                    exchangeQueryForm.formData[i.key] = ''
                })
                getExchangeList()
                break;
            case 'seeFile':
                srcList.value = row.file.split(',')
                visible.value = true
                break;
        }
    }

    const close = (val)=>{
        visible.value = val
    }


    const handleSelectChange = ( val, opt, key )=>{
        exchangeQueryForm.formData[key] = val
        table.value.configs.pagination.current = 1
        getExchangeList()
    }


    // 获取返修列表
    const getExchangeList = async ()=>{
        let param = {
            type:4,
            order_id: props.rowData.id,
        }
        table.value.configs.loading = true
        let res = await OrderApi.getInstance().getReturnExchangeList(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(i=>{
                i.swap_number = !i.swap_number? '-' : i.swap_number
                i.back_number = !i.back_number? '-' : i.back_number
                i.erp_no = !i.erp_no? '-' : i.erp_no
                i.erp_line_no = !i.erp_line_no? '-' : i.erp_line_no
                i.status_val = i.status
                i.product_name = !i.swap_product_map? '-' : i.swap_product_map.english_name
                i.status = formatField('status',i.status)
                i.source = formatField('source',i.source)
                i.back_reason_type = formatField('back_reason_type',i.back_reason_type)
                i.ibs_verification_type = i.ibs_verification_type == undefined ? '-' : formatField('ibs_verification_type', i.ibs_verification_type)
                i.ibs_verification_plan = i.ibs_verification_plan == undefined? '-' : i.ibs_verification_plan,
                i.discount = '€ ' + i.discount
                i.customer_erp_code = i.customer_erp_code == undefined? '-' : i.customer_erp_code
                i.swap_timestamp_plan = timestampToDate(i.swap_timestamp_plan * 1000)
                i.swap_timestamp_real = i.swap_timestamp_real == undefined? '-' : timestampToDate(i.swap_timestamp_real * 1000)
                i.back_courier_no = i.back_courier_map == undefined ? '-' : i.back_courier_map.courier_no
                i.back_courier_type = i.back_courier_map == undefined ? '-' : i.back_courier_map.courier_type
                i.back_courier_status_val = i.back_courier_map == undefined || i.back_courier_map.courier_status == undefined? '-' : i.back_courier_map.courier_status
                i.back_courier_status = i.back_courier_map == undefined || i.back_courier_map.courier_status == undefined? '-' : courierStatus.value[i.back_courier_map.courier_status]
                i.swap_courier_no = i.swap_courier_map == undefined ? '-' : i.swap_courier_map.courier_no
                i.swap_courier_type = i.swap_courier_map == undefined ? '-' : i.swap_courier_map.courier_type
                i.model = i.swap_product_map == undefined ? '-' : i.swap_product_map.model == undefined? '-' : i.swap_product_map.model
                i.model_year = i.swap_product_map == undefined ? '-' : i.swap_product_map.model_year == undefined? '-' : i.swap_product_map.model_year
                i.brand_name = i.swap_product_map == undefined ? '-' : i.swap_product_map.brand_name == undefined? '-' :  i.swap_product_map.brand_name
                i.part_name = i.swap_product_map == undefined ? '-' : i.swap_product_map.part_name == undefined? '-' :  i.swap_product_map.part_name
            })
            table.value.datas = res.data
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取原因类型
    const getReasonType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "back_reason"})
        if(res.code == 0){
            let item = exchangeQueryForm.formField.find(i=> i.key == 'back_reason_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })  

            item.options.forEach(i=>{
                reasonTypeObj.value[Number(i.value)] = i.label
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取IBS验证方案类型
    const getIBSType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "IBS_verification_type"})
        if(res.code == 0){
            res.data.forEach(i=>{
                IBSTypeObj.value[Number(i.dict_sub_value)] = i.dict_sub_name
            })
            console.log(IBSTypeObj.value,'IBSTypeObj')
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型
    const getOrderSource = async ()=>{
        // let res = await OrderApi.getInstance().getCourierType({dict_code: "erp",dict_sub_code: "customer"})
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            res.data.forEach(i=>{
                sourceObj.value[i.id] = i.id == 1? 'Shopify' : i.customer_name
            })
        }else{
            Message.error(res.msg)
        }
    }

    watch(()=>props.visible,(val)=>{
        if(val) getExchangeList()
    })

    onMounted(async ()=>{
        await getOrderSource()
        await getReasonType()
        await getIBSType()
        getExchangeList()
    })
</script>

<style lang="less" scoped>
.collapse{
    margin-bottom: 10px;
    /deep/ .arco-collapse-item-content{
        background-color: #fff;
    }

    .form_btn{
        margin: 0 10px;
    }
}
/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}
</style>